import React from "react";

import styled from "@emotion/styled";

import gasIcon from "../../../../../../images/oeko_gas.jpg";
import { formatNumber } from "../../../../../../utils/NumberHelpers";
import {
    adjustButtonMargin,
    ExpandedContent,
    ProductDetails,
    ProductRow,
    ProductRowLabel,
    ProductRowValue,
    ToggleMore,
} from "../../../../../shared/CalculatorProductDetails";
import List from "../../../../../shared/List";
import Button from "../../../../../shared/NewForms/Button";

const GasIconWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const GasIcon = styled.img`
    width: 50%;
`;

const GasProduct = ({ consumption, product, onSubmit, expanded, onExpand }) => {
    return (
        <ProductDetails>
            <ProductRow>
                <ProductRowLabel>Bedarf:</ProductRowLabel>
                <ProductRowValue>
                    {formatNumber(consumption)} kWh
                </ProductRowValue>
            </ProductRow>
            <ProductRow>
                <ProductRowLabel>Arbeitspreis:</ProductRowLabel>
                <ProductRowValue>
                    {product.arbeitspreisCtKWhBrutto} ct/kWh
                </ProductRowValue>
            </ProductRow>
            <ProductRow>
                <ProductRowLabel>Grundpreis (brutto):</ProductRowLabel>
                <ProductRowValue>
                    {product.grundpreisBrutto}&nbsp;&euro;/Jahr
                </ProductRowValue>
            </ProductRow>
            <ProductRow>
                <ProductRowLabel>Monats&shy;abschlag:</ProductRowLabel>
                <ProductRowValue>
                    {product.Monatlich}&nbsp;&euro; (brutto)
                </ProductRowValue>
            </ProductRow>
            <ProductRow>
                <ProductRowLabel>Gesamt:</ProductRowLabel>
                <ProductRowValue>
                    {product.gesamtpreisOhneBoniBrutto}&nbsp;&euro;
                </ProductRowValue>
            </ProductRow>

            <Button
                color="red"
                css={adjustButtonMargin}
                fullWidth
                onClick={onSubmit}
            >
                Bestellen
            </Button>

            <ToggleMore onClick={onExpand}>
                {expanded ? "Weniger Details -" : "Mehr Details +"}
            </ToggleMore>

            {expanded && (
                <ExpandedContent>
                    <List withContentWrapper clearLeftSpace>
                        <List.Item>
                            Kündigungsfrist:{" "}
                            <strong>{product.kuendigungsfrist}</strong>
                        </List.Item>
                        <List.Item>
                            Mindestvertragslaufzeit:{" "}
                            <strong>{product.vertragsverlaengerung}</strong>
                        </List.Item>

                        <List.Item>
                            Eingeschränkte Preisgarantie für 12 Monate:{" "}
                            <strong>
                                ({product.preisgarantieBestandteile})
                            </strong>
                        </List.Item>
                        <List.Item>
                            Alle angezeigten Preise sind Bruttopreise und
                            beinhalten alle Steuern und Abgaben.
                        </List.Item>
                        <List.Item>
                            Stand:{" "}
                            {product.gueltigVon.split("-").reverse().join(".")}
                        </List.Item>
                    </List>
                    <GasIconWrapper>
                        <GasIcon src={gasIcon} alt="Öko Gas" />
                    </GasIconWrapper>
                </ExpandedContent>
            )}
        </ProductDetails>
    );
};

export default GasProduct;
